'use client';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

interface FocusModeContextValue {
  isFocusMode: boolean; // true = TVA filter active (default for admin)
  activateFocusMode: () => void;
  deactivateFocusMode: () => void;
}

const FocusModeContext = createContext<FocusModeContextValue>({
  isFocusMode: true,
  activateFocusMode: () => {},
  deactivateFocusMode: () => {},
});

export const useFocusMode = () => useContext(FocusModeContext);

export function FocusModeProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const role = user?.role;
  // Admin defaults to focus mode (TVA filter on)
  const [isFocusMode, setIsFocusMode] = useState(true);

  const activateFocusMode = () => setIsFocusMode(true);
  const deactivateFocusMode = () => {
    if (role === 'admin') setIsFocusMode(false);
  };

  // Reset to focus mode on logout / role change
  useEffect(() => {
    setIsFocusMode(true);
  }, [role]);

  return (
    <FocusModeContext.Provider data-component-id="src/contexts/FocusModeContext.tsx:36:4" data-component-path="src/contexts/FocusModeContext.tsx" data-component-line="36" data-component-end-line="38" data-component-file="FocusModeContext.tsx" data-component-name="FocusModeContext.Provider" data-component-content="%7B%22elementName%22%3A%22FocusModeContext.Provider%22%7D" value={{ isFocusMode, activateFocusMode, deactivateFocusMode }}>
      {children}
    </FocusModeContext.Provider>
  );
}
